import { ClipboardCheck, FileText, Images, LayoutDashboard, ListTree } from 'lucide-react'
import { useState } from 'react'
import { useScrollDirection } from '../hooks/useScrollDirection'
import { useI18n } from '../core/i18n'
import type { NavigationItem } from '../types'

const targets = [
  { id: 'overview', icon: LayoutDashboard, key: 'overview' },
  { id: 'timeline', icon: ListTree, key: 'timeline' },
  { id: 'media', icon: Images, key: 'media' },
  { id: 'documents', icon: FileText, key: 'documents' },
  { id: 'questions', icon: ClipboardCheck, key: 'questions' },
] as const

const iconById = Object.fromEntries(targets.map((item) => [item.id, item.icon]))

const fallbackTarget: Record<string, string> = { media: 'timeline', documents: 'timeline', questions: 'timeline' }
const legacyLabels: Record<string, string> = {
  '진료 요약': '반려동물',
  '타임라인': '날짜순 기록',
  '사진·영상': '사진과 영상',
  '문서': '진료자료',
  '진료 질문': '물어볼 내용',
  '궁금한 점': '물어볼 내용',
}

export function canonicalNavigationLabel(label: string) {
  return legacyLabels[label] || label
}

export function canonicalNavigationTarget(item: NavigationItem) {
  const configuredTarget = item.target.startsWith('#') ? item.target.slice(1) : item.target
  return Object.prototype.hasOwnProperty.call(iconById, item.id) ? item.id : configuredTarget
}

export function canonicalNavigationIconTarget(item: NavigationItem) {
  const target = canonicalNavigationTarget(item)
  return Object.prototype.hasOwnProperty.call(iconById, target) ? target : 'timeline'
}

export function navigateToPageSection(rawTarget: string) {
  const requestedId = rawTarget.startsWith('#') ? rawTarget.slice(1) : rawTarget
  const target = document.getElementById(requestedId) || document.getElementById(fallbackTarget[requestedId] || '')
  if (!target) return false
  if (target instanceof HTMLDetailsElement) target.open = true
  if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1')
  const top = Math.max(0, target.getBoundingClientRect().top + window.scrollY - 84)
  window.scrollTo({ top, behavior: 'smooth' })
  target.focus({ preventScroll: true })
  return true
}

export function BottomNav({ items }: { items?: NavigationItem[] }) {
  const visible = useScrollDirection()
  const { tr, locale } = useI18n()
  const [activeId, setActiveId] = useState('overview')
  const navigation = items?.length ? items.filter((item) => item.enabled).slice(0, 5) : targets.map(({ id, key }) => ({ id, target: `#${id}`, label: tr[key], labelEn: tr[key], enabled: true, order: 0 }))
  return (
    <nav className={`bottom-nav glass-panel ${visible ? 'is-visible' : 'is-hidden'}`} aria-label="페이지 바로가기">
      {navigation.map((item) => { const id = canonicalNavigationTarget(item); const Icon = iconById[canonicalNavigationIconTarget(item)] || ListTree; const label = locale === 'ko' ? canonicalNavigationLabel(item.label) : item.labelEn || item.label; return <button type="button" key={item.id} className={activeId === item.id ? 'active' : ''} aria-current={activeId === item.id ? 'location' : undefined} onClick={() => { if (navigateToPageSection(id)) setActiveId(item.id) }}><Icon size={20} aria-hidden="true" /><span>{label}</span></button> })}
    </nav>
  )
}
